// Import manifests as URLs so Parcel processes them
const manifestUrl = new URL('./manifest.webmanifest', import.meta.url).toString();
const desktopManifestUrl = new URL('./manifest.desktop.webmanifest', import.meta.url).toString();

const injectManifest = () => {
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  const targetManifest = isMobile ? manifestUrl : desktopManifestUrl;

  const link = document.createElement('link');
  link.rel = 'manifest';
  link.href = targetManifest;
  document.head.appendChild(link);
};

injectManifest();
